const SocialSecurity = ({ size = 54 }) => (
  <svg
    id="SocialSecurity"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 54 54"
    fill="none"
  >
    <path
      d="M47.5558 14.706H13.219C11.6483 14.706 10.375 15.9793 10.375 17.55V40.5216C10.375 42.0923 11.6483 43.3656 13.219 43.3656H47.5558C49.1265 43.3656 50.3998 42.0923 50.3998 40.5216V17.55C50.3998 15.9793 49.1265 14.706 47.5558 14.706Z"
      fill="#FF6082"
    />
    <path
      d="M42.0408 39.3912H6.43862C4.27862 39.3912 2.52002 37.6344 2.52002 35.4726V13.473C2.52002 11.313 4.27862 9.5544 6.43862 9.5544H42.0408C44.2008 9.5544 45.9594 11.313 45.9594 13.473V35.4726C45.9594 37.6326 44.2008 39.3912 42.0408 39.3912ZM6.43862 11.7162C5.46842 11.7162 4.68002 12.5046 4.68002 13.4748V35.4744C4.68002 36.4446 5.46842 37.233 6.43862 37.233H42.0408C43.011 37.233 43.7994 36.4446 43.7994 35.4744V13.4748C43.7994 12.5046 43.011 11.7162 42.0408 11.7162H6.43862Z"
      fill="#5A348C"
    />
    <path
      d="M38.5092 21.6468H16.2504C15.6546 21.6468 15.1704 21.1626 15.1704 20.5668C15.1704 19.971 15.6546 19.4868 16.2504 19.4868H38.5092C39.105 19.4868 39.5892 19.971 39.5892 20.5668C39.5892 21.1626 39.105 21.6468 38.5092 21.6468Z"
      fill="#5A348C"
    />
    <path
      d="M27.7166 27.126H16.2524C15.6566 27.126 15.1724 26.6418 15.1724 26.046C15.1724 25.4502 15.6566 24.966 16.2524 24.966H27.7166C28.3124 24.966 28.7966 25.4502 28.7966 26.046C28.7966 26.6418 28.3124 27.126 27.7166 27.126Z"
      fill="#5A348C"
    />
    <path
      d="M30.674 32.6052H16.2524C15.6566 32.6052 15.1724 32.121 15.1724 31.5252C15.1724 30.9294 15.6566 30.4452 16.2524 30.4452H30.674C31.2698 30.4452 31.754 30.9294 31.754 31.5252C31.754 32.121 31.2698 32.6052 30.674 32.6052Z"
      fill="#5A348C"
    />
  </svg>
);

export default SocialSecurity;
